function isRepeatPurchaser(orderCount, isGuest) {
    if (isGuest) return 'NonShopper';
    if (orderCount > 0) return 'Repeat';

    return 'New';
}

/**
 * Adobe Digital Data User node DataLayer.
 */
module.exports = function (data) {
    return {
        user: {
            status: data.shopperDetails.ShopperStatusId,
            userType: data.shopperDetails.ABN && data.shopperDetails.ABN !== '' ? 'Business' : 'Personal',
            newRepeatPurchase: isRepeatPurchaser(data.shopperDetails.OrderCount, data.shopperDetails.IsGuest),
            profile: {
                profileInfo: {
                    shopperID: data.shopperDetails.Id,
                },
                attributes: {
                    EDR: !data.shopperDetails.RewardsCardNumber || data.shopperDetails.RewardsCardNumber === '' ? 'No' : 'Yes',
                    orderCount: data.shopperDetails.OrderCount,
                    deliverySaverExpiryDate: data.shopperDetails.ActiveDeliverySaverExpiryDate,
                    emailOptIn: data.shopperDetails.EmailOptIn,
                    emailWidgetOptIn: data.shopperDetails.EmailWidgetOptIn,
                },
            },
        },
    };
};



// WEBPACK FOOTER //
// ./src/auth/shopper/analytics/shopper-analytics-dtm-mapper.js